import { Routes, Route } from 'react-router-dom';
import { HomePage } from './components/HomePage';
import { ServicePage } from './components/ServicePage';
import { ChatbotPage } from './components/ChatbotPage';
import { ReportPage } from './components/ReportPage';
import { RegisterForm } from './components/RegisterForm';
import { MovarToolsPage } from './components/MovarToolsPage';
import { AIPolicyPage } from './components/AIPolicyPage';
import { useState } from 'react';
import { Chatbot } from './components/Chatbot';

function App() {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);
  const [initialMessage, setInitialMessage] = useState<string>('');

  const handleOpenChat = (message?: string) => {
    setInitialMessage(message || '');
    setIsChatbotOpen(true);
  };

  return (
    <div className="min-h-screen text-white">
      <Routes>
        <Route path="/" element={<HomePage onOpenChat={handleOpenChat} />} />
        <Route path="/movar-tools" element={<MovarToolsPage />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/chatbot" element={<ChatbotPage />} />
        <Route path="/report" element={<ReportPage />} />
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/ai-policy" element={<AIPolicyPage />} />
      </Routes>
      {isChatbotOpen && (
        <Chatbot
          onClose={() => setIsChatbotOpen(false)}
          initialMessage={initialMessage}
        />
      )}
    </div>
  );
}

export default App;
